import type { ResultsAiManager } from '@/state/results-ai/useResultsAi';
import { AiAskField } from '@/components/ai-chat';

type ResultsAiAskFieldProps = { manager: ResultsAiManager };

/**
 * Ask about the experiment, in its header on every tab, where Start and End used to be (decided
 * 2026-10-20): the shared field, which turns into the pressed Ink "Ask" while the panel is open.
 * Hidden while the assistant is off.
 */
export const ResultsAiAskField = ({ manager }: ResultsAiAskFieldProps) => {
  if (!manager.available) return null;
  return (
    <AiAskField
      open={manager.open}
      onToggle={manager.toggle}
      busy={manager.busy}
      draft={manager.draft}
      onDraftChange={manager.setDraft}
      onSubmit={() => void manager.submitFromField()}
      label="Ask about this experiment"
      placeholder="Ask about this experiment"
      tourAnchor="results-ask-ai"
    />
  );
};
